module.exports = __webpack_public_path__ + "static/media/se.7167df83.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/se.svg
// module id = 2205
// module chunks = 0